( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-contact-us' );

		if ( !$section.find( '.js-faq-item-toggler' ).length ) {
			return false;
		} else {

			$section.find( '.js-faq-item-toggler' ).on( 'click', function( e ) {
				e.preventDefault();
				let $btn = $( this );
				let $accordionItem = $btn.parents( '.faq-item' );
				let $accordionItemCollapse = $accordionItem.find( '.faq-item__body' );

				if ( !$accordionItem.hasClass( 'opened' ) ) {
					$section.find( '.js-faq-item-toggler' ).attr( 'disabled', true );
					$accordionItem.siblings().removeClass( 'opened' );
					$accordionItem.siblings().find( '.faq-item__body' ).collapse( 'hide' );
					$accordionItem.addClass( 'opened' );
					$accordionItemCollapse.collapse( 'show' );
					$accordionItemCollapse.on( 'shown.bs.collapse', function() {
						$section.find( '.js-faq-item-toggler' ).removeAttr( 'disabled' );
					} );
				} else {
					if ( $section.find( '.faq-item.opened' ).length > 1 ) {
						$section.find( '.js-faq-item-toggler' ).attr( 'disabled', true );
						$accordionItem.siblings().removeClass( 'opened' );
						$accordionItem.siblings().find( '.faq-item__body' ).collapse( 'hide' );
						$accordionItem.removeClass( 'opened' );
						$accordionItemCollapse.collapse( 'hide' );
						$accordionItemCollapse.on( 'hidden.bs.collapse', function() {
							$section.find( '.js-faq-item-toggler' ).removeAttr( 'disabled' );
						} );
					}
				}
			} );
		}
	};

	window.app.loadBlock( initBlock, 'section-contact', '.section-contact-us' );
} )( jQuery );